<template>
  <div class="order user-orders" ref="order" style="padding-top: 46px;">
    <tr-list request="/BizMemberParentOrder/MyListNew" ref="trList" :data="{Type: '租赁'}">
      <template slot="list" slot-scope="props">
<!--        :tag-type="(items.State === '待支付' || items.State === '退款中') ? 'warning' : (items.State === '待安装' || items.State === '已支付' || items.State === '已开通') ? 'success' : items.State === '退款失败'? 'danger' : 'info'"-->
<!--        :top-left-text="items.PayType"-->
<!--        :top-left-bg-color="items.PayType === '线下支付' ? '#FFC107' : items.PayType === '余额支付' ? '#FF5F4E' : '#19C82A'"-->
        <list-group
            :tag="items.State"
            :tag-type="(items.State === '退款中' || items.State === '将到期') ? 'warning' : (items.State === '进行中') ? 'success' : items.State === '退款失败'? 'danger' : 'info'"
            v-for="(items, index) in props.list" :key="index"
            style="margin-top: 15px"
            top-right-label="合同编号"
            flex-direction = 'row-reverse'
            :top-right-value="items.Code"
            :title="items.PackageName"
            foot-right-width="110px"
            @click.native="goToDetail(items)"
            >
          <template slot="content">
            <div class="item">
              <div>
                <svg-icon icon-class="租金" color="#999999"></svg-icon>
                套餐租金：￥{{ items.PackagePrice }}
              </div>
              <div>
                <svg-icon icon-class="押金" color="#999999"></svg-icon>
                套餐押金：￥{{ items.PackageDeposit }}
              </div>
            </div>
            <div class="item">
              <div>
                <svg-icon icon-class="租金" color="#999999"></svg-icon>
                合同租金：￥{{ items.Price }}
              </div>
              <div>
                <svg-icon icon-class="押金" color="#999999"></svg-icon>
                合同押金：￥{{ items.Deposit }}
              </div>
            </div>
            <div class="addr">
              <div>
                <svg-icon icon-class="地址" color="#999999"></svg-icon>
                地址：
              </div>
              <div>
                <div>{{ items.RegionName }}</div>
                <div>{{ items.FullAddress }}</div>
              </div>
            </div>
          </template>
          <template slot="footLeft">
            <div>
              <div>
                <div style="display: flex;line-height: 26px">
                  <div>
                    <svg-icon icon-class="合同有效期" color="#999999"></svg-icon>
                    下单时间：
                  </div>
                  <div>{{items.CreateTimeStr}}</div>
                </div>
              </div>
              <div>
                <div style="display: flex;line-height: 26px;">
                  <div>
                    <svg-icon icon-class="合同有效期" color="#999999"></svg-icon>
                    有效日期：
                  </div>
                  <div>{{items.EndTimeStr}}</div>
                </div>
              </div>
            </div>
          </template>
          <template slot="orderlist">
            <div v-for="(itemChild,index) in items.bizOrderListInfos" :key="index">
              <div class="olist">
                <div>
                  <div>
                    <span :class="itemChild.PayType=='余额支付'?'success':'primary'">{{itemChild.PayType}}</span>
                    <p>订单{{index+1}}</p>
                  </div>
                  <p style="font-size:12px;color:#999;">{{itemChild.PayMemberName}}</p>

                </div>
                <div>
                  <p>支付押金：{{itemChild.EditDeposit}}</p>
                  <p>支付租金：{{itemChild.EditPrice}}</p>
                  <p>状态：{{itemChild.State}}</p>
                </div>
              </div>
            </div>
          </template>

<!--          <template slot="footLeft" >-->
<!--            <div style="display: flex;justify-content: space-between;width: 100%;align-items: baseline;">-->
<!--              <div class="yxq">-->
<!--                <div>-->
<!--                  <div>-->
<!--                    <svg-icon icon-class="合同有效期" color="#999999"></svg-icon>-->
<!--                    {{items.PackageEndTimeStr ? `有效期至${items.PackageEndTimeStr}` : '' }}-->
<!--                  </div>-->

<!--                  <div>-->
<!--                    <svg-icon icon-class="下单日期" color="#999999"></svg-icon>-->
<!--                    下单日期：{{ items.CreateTimeStr }}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div style="margin-left:10px">-->
<!--                 {{ items.PackageMode }}-->
<!--              </div>-->
<!--            </div>-->

<!--          </template>-->
          <template slot="footRight">
            <div class="btnSpanOne">
<!--              <span @click="goToDetail(items)">详情 </span>-->
              <span class="btnSpanThree" @click.stop="handleReturn(items)" v-if="items.IsCanReturn">退租</span>
<!--              <wx-pay :params="{Id: items.ParentOrderId}" v-if="(items.State === '待支付' || items.State === '支付中') && items.IsOnline === true"-->
<!--                      style="display: flex;align-items: center" @successPay="successPay" @refresh="refresh">-->
<!--                <span class="btnSpanTwo">去支付</span>-->
<!--              </wx-pay>-->
            </div>
          </template>
        </list-group>
      </template>
    </tr-list>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import listGroup from "@/views/modules/listGroup.vue";
import {setCookie} from "@/utils/cookie";

export default {
  name: 'home',
  data() {
    return {
      active: 1,
      typeStatus: [
        {
          name: '租赁',
          url: '/BizMemberOrder/List'
        },
        {
          name: '报修',
          url: '/BizMemberService/List'
        },
        {
          name: '退租',
          url: '/BizMemberReturn/MyList'
        }
      ],
      activeList: [],
    }
  },
  watch: {
    active(val) {
      this.$store.dispatch('orderActive', val)
      if (val !== undefined) {
        if (this.activeList.length < this.typeStatus.length) {
          this.activeList.push(val)
          this.activeList = this.uniq(this.activeList)
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'orderactive'
    ])
  },
  components: {listGroup},
  methods: {
    refresh(){
      this.$refs.trList.onRefresh();
    },
    handleReturn(item) {
      this.$router.replace({name: 'orderMain', query: { backUrl: 'userOrder', OrderId: item.ParentOrderId,type: '退租',title: '退租', backQuery: JSON.stringify(this.$route.query) }})
    },
    uniq(arr) {
      var res = [];
      for (var i = 0; i < arr.length; i++) {
        if (res.indexOf(arr[i]) == -1) {
          res.push(arr[i]);
        }
      }
      return res;
    },
    changeTab(index, title) {
      this.$refs.order.scrollTop = 0
      var active = this.activeList.indexOf(index)
      if (active !== -1) {
        this.$refs.trList[active].onRefresh()
      }
    },
    successPay(val) {
      this.$toast.loading().clear()
      if (val === 'chooseWXPay:ok') {
        this.$dialog.alert({
          message: '订单支付成功！'
        }).then(() => {
          this.$refs.trList.onRefresh();
        })
      } else {
        this.$toast.fail('支付失败！');
      }
    },
    stateColor(item) {
      return item.State === '已完成' ? '#00d8a0' : item.State === '待支付' ? '#fe6466' : item.State === '将到期' ? '#df0000' : '#666';
    },
    goToDetail(items) {
      this.$router.replace({
        path: '/userIn/orderDetails',
        query: {Id: items.Id, backUrl: 'userOrder', backQuery: JSON.stringify({backUrl: this.$route.query.backUrl})}
      })
    }
  },
  mounted() {
  },
  created() {
    this.active = this.orderactive
  }
}
</script>
<style lang="less">
//.list-group-module .list-group .foot{
//  display: block!important;
//}
.foot{
 margin-bottom:10px;
}
.olist{
  background:#f2f2f2;
  margin-bottom:10px;
  border-radius: 5px;
  padding: 8px 10px;
  > div:nth-child(1){
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:5px;
    span{
      background:#ccc;
      padding:2px 4px;
      border-radius: 5px;
      margin:0;
      margin-right:5px;
      font-size:11px;
      color:#fff;
    }
    .success{
      background:#67c23a;
    }
    .primary{
      background:#409eff;
    }
    > div{
      display: flex;
    }
  }
  > div:nth-child(2){
    display: flex;
    p{
      margin-right:20px;
      font-size: 12px;
      color:#606266;
    }
    p:last-child{
      margin-right:0;
    }
  }
  p{
    margin:0;
  }
}
.order-describe {
  padding: 5px 15px;

  p {
    margin: 5px 0;
  }

  p:nth-child(1) {
    color: #999;
    font-size: 14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;

    span {
      color: #666;
      font-size: 14px;
    }
  }
}

.order {
  .order-time {
    font-size: 16px;
  }

  .order-state {
    color: #fe6466;
    font-size: 20px;
    display: block;
  }

  .IsOnlineStr {
    font-style: normal;
  }

  .combo {
    p:nth-child(1) {
      margin: 5px 0;
      color: #666;
      overflow: hidden;

      span:nth-child(1) {
        display: inline-block;
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
      }

      span:nth-child(2) {
        line-height: 24px;
        color: #999;
        float: right;
      }
    }

    p:nth-child(2) {
      color: #999;
      margin: 5px 0;
      font-size: 14px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }

  .order-footer {
    text-align: right;
    padding: 8px 15px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    &:after {
      content: ' ';
      position: absolute;
      pointer-events: none;
      box-sizing: border-box;
      left: 0.4rem;
      right: 0;
      top: 0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
      border-bottom: 0.026667rem solid #ebedf0;
    }

    .Price {
      float: right;

      dl, dd, dt {
        margin: 0;
        vertical-align: baseline;
      }

      > ul:last-child {
        overflow: hidden;

        dl {
          float: left;
          margin-right: 5px;
        }

        dd {
          color: #999;
          font-size: 12px;
        }
      }

      > ul:first-child {
        display: flex;
        justify-content: flex-start;

        dl {
          margin-right: 5px;
        }

        dt {
          line-height: 22px;
        }

        dd {
          color: #fe6466;
          font-size: 16px;
        }
      }

      dt {
        font-size: 12px;
        display: inline-block;
        float: left;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        text-align: center;
        line-height: 18px;
      }

      dd {
        float: left;
      }
    }
  }

  .van-tabs__line {
    background-color: #00d8a0;
  }

  .van-cell {
    .van-cell__label {
      margin-top: 5px;
    }
  }

  .van-col--24 {
    color: #666;

    dl {
      margin: 0;
      font-size: 12px;
      overflow: hidden;

      dt {
        float: left;
      }

      dd {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        color: #999999;
        margin: 0;
      }
    }

    dl:last-child {
      dd {
        -webkit-line-clamp: 2;
      }
    }
  }

  .van-col--8 {
    text-align: right;

    div {
      padding: 3px;
      font-size: 12px;
      color: #999999;
    }
  }

  .btnSpanOne {
    float: right;
    //background-color: #898989;
    color: #ffffff;
    line-height: 26px;
    padding: 0 12.5px;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: 12px;
    }

    > span {
      padding: 0 5px;
    }
  }

  .btnSpanTwo {
    background-color: #19C82A;
    color: #ffffff;
    display: inline-block;
    height: 26px;
    padding: 0 15px;
    margin-right: -13px;
    border-radius: 14px;
  }

  .btnSpanThree {
    background-color: #FFC107;
    color: #ffffff;
    display: inline-block;
    height: 26px;
    padding: 0 15px !important;
    margin-right: -13px;
    border-radius: 14px;
  }
}
</style>
<style lang="less" scoped>
.user-orders {
  .item {
    color: #999999;
    display: flex;
    align-items: center;
    line-height: 24px;

    > div {
      display: flex;
      align-items: center;

      &:nth-child(1) {
        margin-right: 20px;
      }
    }

    .svg-icon {
      font-size: 16px !important;
    }
  }

  .addr {
    color: #999999;
    display: flex;
    line-height: 24px;
  }

  .yxq {
    display: flex;

    > div {
      line-height: 24px;
    }
  }
}
</style>
